import { getCookie, setCookie } from './cookies';

const isSupported = () => {
  if (!window) { return false; }

  try {
    const testKey = "__test-local-storage__";
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}

const isLocalStorageSupported = isSupported();

export const setToLocalStorage = (name, value) => {
  if(isLocalStorageSupported) {
    window.localStorage.setItem(name, value);
  } else {
    setCookie(name, value, 1);
  }
};

export const getFromLocalStorage = (name) => {
  if(isLocalStorageSupported) {
    return window.localStorage.getItem(name);
  } else {
    return getCookie(name);
  }
};
